import ALARM_STATES from '../pages/app/Temperature/alarmSettings'
import prioritizeAlarms from '../pages/app/Temperature/prioritizeAlarms'

export const showTargetValue = props => {
	const target = props?.target
	if (!target) return '-'
	return target + ' °C'
}

export const tenantAddress = tenant => {
	const { attributes } = tenant.configuration
	let finalString = ''
	if (attributes.address) finalString += attributes.address + ', '
	if (attributes.zip) finalString += attributes.zip + ' '
	if (attributes.city) finalString += attributes.city
	return finalString
}

export const getCurrentAlarmState = attributes => {
	if (!attributes) return null
	const relevantStates = [
		ALARM_STATES.DEFROST,
		ALARM_STATES.WARMUP,
		ALARM_STATES.WARNING,
		ALARM_STATES.ALARM,
	]

	const filteredMeasurements = Object.keys(attributes)
		.filter(key => relevantStates.includes(key))
		.map(key => ({
			measuredValue: key,
			value: attributes[key],
		}))
	const highestPriority = prioritizeAlarms(filteredMeasurements)
	return highestPriority
}
